export default {
    kh: 'ខ្មែរ',
    en: 'អង់គ្លេស',
    lao:"ឡាវ",
    thai:"ថៃ"
};
